export default "__VITE_ASSET__DpOnRaHT__"